import { defineMessages } from 'react-intl';

export default defineMessages({
  nothingBorrowed: 'Nothing borrowed yet',
  nothingBorrowedDescription:
    'There will be a list of all the assets you have borrowed. For now, it’s empty since you have not borrowed.',
  borrowNow: 'Borrow now',
});
